/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Components/RepoCodeCoverage" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { IObservableValue } from "VSS/Core/Observable";
import { IVssPerformanceService } from "VSS/Platform/Performance";

import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import { CoverageChangeSummaryResponse, PipelineCoverageSummary } from "CodeCoverage/Clients/Coverage/Contracts/Coverage";
import { ResponsiveCodeCoverageCiSummaryView } from "CodeCoverage/CodeCoverageCiTab/Components/ResponsiveCodeCoverageCiSummaryView";
import { CodeCoverageCiTabBar } from "CodeCoverage/CodeCoverageCiTab/Components/CodeCoverageCiTabBar";
import { CodeCoverageHtmlView } from "CodeCoverage/CodeCoverageCiTab/Components/CodeCoverageHtmlView";
import * as Resources from "CodeCoverage/CodeCoverageCiTab/Resources";
import { PerfScenarios } from "CodeCoverage/ViewCommon/Constants";
import { CoverageEvaluationStatus } from "CodeCoverage/ViewCommon/Contracts/Common";
import { RunViewArtifact } from "CodeCoverage/ViewCommon/RunViewArtifact";

export interface IRepoCodeCoverageProps {
    runViewArtifact: RunViewArtifact;
    changedFiles: CoverageChangeSummaryResponse;
    pipelineCoverageSummary: IObservableValue<PipelineCoverageSummary>;
    htmlSummaryLink: IObservableValue<string | undefined>;
}

export class RepoCodeCoverage extends VssComponent<IRepoCodeCoverageProps> {
    public componentDidMount(): void {
        super.componentDidMount();

        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.markTimeToInteractive(PerfScenarios.Area, PerfScenarios.CodeCoverageCiTab);
    }

    public render(): JSX.Element {
        return (
            <Observer pipelineCoverageSummary={this.props.pipelineCoverageSummary} htmlSummaryLink={this.props.htmlSummaryLink}>
                {(props: { pipelineCoverageSummary: PipelineCoverageSummary; htmlSummaryLink: string | undefined }) => {
                    if (!props.htmlSummaryLink) {
                        return (
                            <div className="repo-codecoverage-container">
                                {props.pipelineCoverageSummary.evaluationStatus === CoverageEvaluationStatus.InProgress ? (
                                    <Spinner className="flex-grow" size={SpinnerSize.large} label={Resources.CoverageEvaluationInProgress} />
                                ) : (
                                    <>
                                        <ResponsiveCodeCoverageCiSummaryView
                                            coverageSummary={this.props.pipelineCoverageSummary.value.summary}
                                            coverageChanged={this.props.pipelineCoverageSummary.value.coverageChange}
                                        />
                                        <Card className="flex-grow" contentProps={{ contentPadding: false }}>
                                            <CodeCoverageCiTabBar
                                                summaryResponse={this.props.changedFiles}
                                                runViewArtifact={this.props.runViewArtifact}
                                            />
                                        </Card>
                                    </>
                                )}
                            </div>
                        );
                    } else {
                        return <CodeCoverageHtmlView codeCoverageSummaryLink={props.htmlSummaryLink}></CodeCoverageHtmlView>;
                    }
                }}
            </Observer>
        );
    }
}
